// @ts-check
import {
  Checkbox,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { useStyles } from './index.styles';
import DropDownIcon from '../../../assets/icons/drop.png';
import filterIcon from '../../../assets/icons/filtericon.png';
import { TwoWeekText } from '../constants';
import { HomePageTable1 } from '../../Stock/constants';
import { ToolTipElement } from '../../Stock/ToolTipElement';

/** @type {React.FC<import('../../../typings').IInterestChangeFilterBarProps>} */
const InterestChangeFilterBar = ({ pageState, setPageState }) => {
  const { toggleTable2Dropdown, toggleRemoveWeeksTable2 } = pageState;

  /** @type {import('../../../typings').IStateReducerState} */
  const { isMobile, secondLoading } = useSelector(
    (state) => state.appReducer
  );
  const classes = useStyles();

  const tooltipClickHandler = () =>
    setPageState({
      ...pageState,
      currentType: 'hometable2',
      showModal: true,
    });

  return (
    <div
      className={
        isMobile
          ? classes.filterTextMobileSecondTable
          : classes.filterText
      }
    >
      <div
        style={
          isMobile
            ? { display: 'flex' }
            : { display: 'flex', width: '50%' }
        }
      >
        {isMobile && (
          <div
            className={classes.dropDown2}
            onClick={() =>
              setPageState({
                ...pageState,
                toggleTable2Dropdown: !toggleTable2Dropdown,
              })
            }
          >
            <img
              height='15px'
              width='15px'
              src={DropDownIcon}
              alt='test'
            />
          </div>
        )}
        <div
          className={
            isMobile
              ? classes.headingStyleMobile
              : classes.headingStyle
          }
        >
          Top Open Interest Changes
        </div>
      
        <div
          style={
            !isMobile
              ? { display: 'none' }
              : {
                  height: '20px',
                  width: '20px',
                  marginLeft: '5px',
                  paddingTop: '8px',
                }
          }
          onClick={() =>
            setPageState({
              ...pageState,
              currentFilterType: 'table2',
              showMobileFilterModal: true,
            })
          }
        >
          <img
            height='15px'
            width='15px'
            src={filterIcon}
            alt='test'
          />
        </div>
        <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
          <ToolTipElement
            text={HomePageTable1}
            clickHandler={tooltipClickHandler}
          />
        </div>
      </div>
      <div
        style={isMobile ? { display: 'none' } : { marginTop: '1%' }}
      >
        <FormControlLabel
          style={{ height: '20px', fontWeight: 'bold' }}
          control={
            <Checkbox
              disabled={secondLoading}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 8.6,
                  boxShadow: '0.1px 0.1px 0.5px 0.1px',
                },
              }}
              checked={toggleRemoveWeeksTable2}
              onChange={() =>
                setPageState({
                  ...pageState,
                  toggleRemoveWeeksTable2: !toggleRemoveWeeksTable2,
                })
              }
            />
          }
          label={
            <Typography
              style={
                isMobile
                  ? {
                      fontSize: '0.8rem',
                      lineHeight: '10px',
                    }
                  : { fontSize: '0.8rem' }
              }
            >
              {TwoWeekText}{' '}
            </Typography>
          }
        />
      </div>
      
    </div>
  );
};

export default InterestChangeFilterBar;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/InterestChangeFilterBar/index.jsx